export const defaultOpts = () => ({
  method: 'GET', // *GET, POST, PUT, DELETE, etc.
  mode: 'cors', // no-cors, *cors, same-origin
  cache: 'default', // *default, no-cache, reload, force-cache, only-if-cached
  credentials: 'same-origin', // include, *same-origin, omit
  headers: {
    'Content-Type': 'application/json',
    'X-CSRF-Token': document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content'),
  },
  redirect: 'follow', // manual, *follow, error
  referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
})


export const fetchJson = async (path, opts = {}) => {
  if (opts.useCache) {
    return cachedFetchJson(path, opts);
  }

  const response = await fetch(path, {
    ...defaultOpts(),
    ...opts,
    headers: {
      ...defaultOpts().headers,
      ...opts.headers,
    },
  });

  // Reject request that are 4XX / 5XX
  if (opts.rejectBadRequest && !response.ok) {
    return Promise.reject(response);
  }

  return await response.json();
};

export const fetchHtml = async (path, opts = {}) => {
  const response = await fetch(path, {
    ...defaultOpts(),
    ...opts,
  });
  return await response.text();
};


var fetchCache = {}

// Check whether expire cached items
let cacheExpireInterval = setInterval(() => {
  let now = new Date().getTime()
  Object.keys(fetchCache).forEach(k => {
    if (fetchCache[k].expireAt < now) {
      delete fetchCache[k];
    }
  })
}, 10000)

// TODO: Maybe we should expire cache on turbolink loads as well?

// If called multiple time with same urls & opts, returns the Promise from previous call
export const cachedFetchJson = async (url, opts ={}) => {
  const cacheKey = url + JSON.stringify(opts?.data || {});

  if (!fetchCache[cacheKey]) {
    fetchCache[cacheKey] = {}

    // 30 second cache
    fetchCache[cacheKey].expireAt = new Date().getTime() + (1000 * (opts.expireTime || 30))

    fetchCache[cacheKey].promise = new Promise((resolve, reject) => {
      fetch(url, {...defaultOpts(), ...opts}).then(res => {
        res.json().then(res => {
          resolve(res)
        });
      });
    });

  }
  return fetchCache[cacheKey].promise
}